import { useHistory } from 'react-router-dom';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useValue } from 'libs/react';
import { React } from 'libs/react';
import { RouteManager } from './lib/RouteManager';
/**
 * @component Routing
 * @since 1.0.0
 */
export function Routing(props) {
    const { routes } = props;
    const self = useValue(() => ({
        manager: new RouteManager(routes)
    }));
    const history = useHistory();
    /**
     * @function get
     * @since 1.0.0
     * @hidden
     */
    function get(route) {
        const name = getName(route);
        const opts = getOpts(route);
        return self.manager.retrieve(name, opts);
    }
    /**
     * @function gen
     * @since 1.0.0
     * @hidden
     */
    function gen(route) {
        const name = getName(route);
        const keys = getKeys(route);
        const opts = getOpts(route);
        return self.manager.generate(name, keys, opts);
    }
    /**
     * @function push
     * @since 1.0.0
     * @hidden
     */
    function push(route, after) {
        if (after) {
            setTimeout(() => history.push(gen(route)), after);
            return;
        }
        history.push(gen(route));
    }
    /**
     * @function replace
     * @since 1.0.0
     * @hidden
     */
    function replace(route, after) {
        if (after) {
            setTimeout(() => replace(gen(route)), after);
            return;
        }
        history.replace(gen(route));
    }
    return (React.createElement(RouteContext.Provider, { value: { get, gen, push, replace } }, props.children));
}
/**
 * @function isRoute
 * @since 1.0.0
 * @hidden
 */
function isRoute(route) {
    return typeof route != 'string';
}
/**
 * @function getName
 * @since 1.0.0
 * @hidden
 */
function getName(route) {
    return isRoute(route) ? route.name : route;
}
/**
 * @function getKeys
 * @since 1.0.0
 * @hidden
 */
function getKeys(route) {
    return isRoute(route) ? route.data : {};
}
/**
 * @function getOpts
 * @since 1.0.0
 * @hidden
 */
function getOpts(route) {
    return isRoute(route) ? route.opts : {};
}
/**
 * @function isValidRoute
 * @since 1.0.0
 * @hidden
 */
export function isValidRoute(routes, route) {
    return Object.values(routes).includes(route);
}
/**
 * @function getRouteByPath
 * @since 1.0.0
 * @hidden
 */
export function getRouteByPath(routes, route) {
    var _a;
    // split on / and replace part contains numbers with :id
    let id = null;
    const parts = route.split('/');
    const path = parts
        .map((part) => {
        if (part.match(/\d+/)) {
            id = part;
            return ':id';
        }
        return part;
    })
        .join('/');
    return {
        path: (_a = Object.keys(routes).find((key) => routes[key] === path)) !== null && _a !== void 0 ? _a : 'dashboard',
        id
    };
}
/**
 * @const RouteContext
 * @since 1.0.0
 */
export const RouteContext = createContext({
    get() {
        return '';
    },
    gen() {
        return '';
    },
    push() { },
    replace() { }
});
/**
 * @function useRoute
 * @since 1.0.0
 */
export function useRoute() {
    return useContext(RouteContext);
}
